export default {
    _prefix: "QuestionMessages",
    labels: {
        aiScoringProcessingFailure:
            "Genesys AI failed to process this question.",
        aiScoringLowConfidenceFailure:
            "Genesys AI could not accurately answer this question.",
    },
};
